import { EntryPoint, Image, useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';
import { seoLinks } from './seoLinks';
import * as styles from './styles.css';

export const SEOLinksBlock = () => {
  const deviceType = useDeviceType();

  return (
    <div className={cn(styles['root'], styles[deviceType])}>
      <ul className={cn(styles['grid'], styles[deviceType])}>
        {seoLinks.map(link => (
          <li key={link.title} className={styles['grid-item']}>
            <EntryPoint
              colorType="neutral"
              control={{ type: 'chevron' }}
              href={link.href}
              image={{
                background: 'transparent',
                content: (
                  <Image
                    alt=""
                    borderRadius="12px"
                    height={56}
                    objectFit="contain"
                    preloader={false}
                    src={link.imageSrc}
                    width={56}
                  />
                ),
              }}
              title={link.title}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};
